import { render, staticRenderFns } from "./RespostaCotacaoFreteHistorico.vue?vue&type=template&id=2902d9b3&"
import script from "./RespostaCotacaoFreteHistorico.vue?vue&type=script&lang=js&"
export * from "./RespostaCotacaoFreteHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports